import { createElement, initializeCSPTemplate } from '@syncfusion/ej2-base';
import { NumericTextBox } from '@syncfusion/ej2-inputs';
import { RibbonItemType } from '@syncfusion/ej2-ribbon';
import { RIBBON_ID } from '../ribbon-base/ribbon-constants';
import { RibbonGroupBase } from '../ribbon-interfaces';
// Constants for UI element IDs
export const LAYOUT_PARAGRAPH_GROUP = '_layout_paragraph_group';
export const INDENT_LEFT_ID = '_indent_left';
export const INDENT_RIGHT_ID = '_indent_right';
export const SPACING_BEFORE_ID = '_spacing_before';
export const SPACING_AFTER_ID = '_spacing_after';
/**
 * Layout Paragraph group implementation for simplified mode
 * @private
 */
export class LayoutParagraphGroup extends RibbonGroupBase {
    /**
     * Constructor for LayoutParagraphGroup class
     *
     * @param {DocumentEditorContainer} container - DocumentEditorContainer instance
     */
    constructor(container) {
        super(container);
        this.isInitilized = false;
        this.eventHandlers = {};
        this.isInitilized = false;
        // Create a hidden container for templates
        this.templateContainer = createElement('div', {
            styles: 'position: absolute; visibility: hidden; height: 0; width: 0; overflow: hidden;'
        });
        document.body.appendChild(this.templateContainer);
        // Create template elements
        this.createIndentLeftTemplate();
        this.createIndentRightTemplate();
        this.createSpacingBeforeTemplate();
        this.createSpacingAfterTemplate();
    }
    /**
     * Get the Ribbon items for Layout Paragraph group
     *
     * @returns {RibbonGroupModel} The ribbon group model
     */
    getGroupModel() {
        const id = this.container.element.id + RIBBON_ID;
        const leftIndentTemplate = () => `
            <div class="e-de-ctnr-layout-ribbon-segment e-de-ctnr-layout-tab"
                title="${this.localObj.getConstant('Indent Left')}">
                <div class="e-de-indent-label-container">
               
                    <span class="e-de-ribbon-property-label">${this.localObj.getConstant('Indent Left')}:</span>
                </div>
                <input id="${this.container.element.id + INDENT_LEFT_ID}" class="e-textbox" />
            </div>`;
        const rightIndentTemplate = () => `
            <div class="e-de-ctnr-layout-ribbon-segment e-de-ctnr-layout-tab"
                title="${this.localObj.getConstant('Indent Right')}">
                <div class="e-de-indent-label-container">
              
                    <span class="e-de-ribbon-property-label">${this.localObj.getConstant('Indent Right')}:</span>
                </div>
                <input id="${this.container.element.id + INDENT_RIGHT_ID}" class="e-textbox" />
            </div>
        `;
        const spacingBeforeTemplate = () => `
            <div class="e-de-ctnr-layout-ribbon-segment e-de-ctnr-layout-tab"
                title="${this.localObj.getConstant('Spacing Before')}">
                <div class="e-de-property-label-container">
                   
                    <span class="e-de-ribbon-property-label">${this.localObj.getConstant('Spacing Before')}:</span>
                </div>
                <input id="${this.container.element.id + SPACING_BEFORE_ID}" class="e-textbox" />
            </div>
        `;
        const spacingAfterTemplate = () => `
            <div class="e-de-ctnr-layout-ribbon-segment e-de-ctnr-layout-tab"
                title="${this.localObj.getConstant('Spacing After')}">
                <div class="e-de-property-label-container">
                    <span class="e-de-icon-spaceafter"></span>
                    <span class="e-de-ribbon-property-label">${this.localObj.getConstant('Spacing After')}:</span>
                </div>
                <input id="${this.container.element.id + SPACING_AFTER_ID}" class="e-textbox" />
            </div>
        `;
        return {
            header: this.localObj.getConstant('Paragraph'),
            showLauncherIcon: true,
            id: id + LAYOUT_PARAGRAPH_GROUP,
            enableGroupOverflow: true,
            overflowHeader: this.localObj.getConstant('Paragraph'),
            collections: [
                {
                    items: [
                        {
                            type: RibbonItemType.Template,
                            itemTemplate: initializeCSPTemplate(leftIndentTemplate),
                            ribbonTooltipSettings: {
                                title: this.localObj.getConstant('Indent Left'),
                                content: this.localObj.getConstant('Set the distance between paragraph and left margin')
                            }
                        },
                        {
                            type: RibbonItemType.Template,
                            itemTemplate: initializeCSPTemplate(rightIndentTemplate),
                            ribbonTooltipSettings: {
                                title: this.localObj.getConstant('Indent Right'),
                                content: this.localObj.getConstant('Set the distance between paragraph and right margin')
                            }
                        }
                    ]
                },
                {
                    items: [
                        {
                            type: RibbonItemType.Template,
                            itemTemplate: initializeCSPTemplate(spacingBeforeTemplate),
                            ribbonTooltipSettings: {
                                title: this.localObj.getConstant('Spacing Before'),
                                content: this.localObj.getConstant('Set the spacing before the paragraph')
                            }
                        },
                        {
                            type: RibbonItemType.Template,
                            itemTemplate: initializeCSPTemplate(spacingAfterTemplate),
                            ribbonTooltipSettings: {
                                title: this.localObj.getConstant('Spacing After'),
                                content: this.localObj.getConstant('Set the spacing after the paragraph')
                            }
                        }
                    ]
                }
            ]
        };
    }
    /**
     * Creates indent left input template
     *
     * @returns {void}
     */
    createIndentLeftTemplate() {
        const script = document.createElement('script');
        script.id = this.container.element.id + RIBBON_ID + '_indent_left';
        script.setAttribute('type', 'text/x-template');
        script.innerHTML = `
            <div class="e-de-ctnr-layout-ribbon-segment e-de-ctnr-layout-tab"
                title="${this.localObj.getConstant('Indent Left')}">
                <div class="e-de-indent-label-container">
               
                    <span class="e-de-ribbon-property-label">${this.localObj.getConstant('Indent Left')}:</span>
                </div>
                <input id="${this.container.element.id + INDENT_LEFT_ID}" class="e-textbox" />
            </div>
        `;
        document.head.appendChild(script);
        // Register numeric textbox for initialization
        this.container.ribbon.numericTextBoxCollection.add(this.container.element.id + INDENT_LEFT_ID, 'simplifiedTab');
    }
    /**
     * Creates indent right input template
     *
     * @returns {void}
     */
    createIndentRightTemplate() {
        const script = document.createElement('script');
        script.id = this.container.element.id + RIBBON_ID + '_indent_right';
        script.setAttribute('type', 'text/x-template');
        script.innerHTML = `
            <div class="e-de-ctnr-layout-ribbon-segment e-de-ctnr-layout-tab"
                title="${this.localObj.getConstant('Indent Right')}">
                <div class="e-de-indent-label-container">
              
                    <span class="e-de-ribbon-property-label">${this.localObj.getConstant('Indent Right')}:</span>
                </div>
                <input id="${this.container.element.id + INDENT_RIGHT_ID}" class="e-textbox" />
            </div>
        `;
        document.head.appendChild(script);
        // Register numeric textbox for initialization
        this.container.ribbon.numericTextBoxCollection.add(this.container.element.id + INDENT_RIGHT_ID, 'simplifiedTab');
    }
    /**
     * Creates spacing before input template
     *
     * @returns {void}
     */
    createSpacingBeforeTemplate() {
        const script = document.createElement('script');
        script.id = this.container.element.id + RIBBON_ID + '_spacing_before';
        script.setAttribute('type', 'text/x-template');
        script.innerHTML = `
            <div class="e-de-ctnr-layout-ribbon-segment e-de-ctnr-layout-tab"
                title="${this.localObj.getConstant('Spacing Before')}">
                <div class="e-de-property-label-container">
                   
                    <span class="e-de-ribbon-property-label">${this.localObj.getConstant('Spacing Before')}:</span>
                </div>
                <input id="${this.container.element.id + SPACING_BEFORE_ID}" class="e-textbox" />
            </div>
        `;
        document.head.appendChild(script);
        // Register numeric textbox for initialization
        this.container.ribbon.numericTextBoxCollection.add(this.container.element.id + SPACING_BEFORE_ID, 'simplifiedTab');
    }
    /**
     * Creates spacing after input template
     *
     * @returns {void}
     */
    createSpacingAfterTemplate() {
        const script = document.createElement('script');
        script.id = this.container.element.id + RIBBON_ID + '_spacing_after';
        script.setAttribute('type', 'text/x-template');
        script.innerHTML = `
            <div class="e-de-ctnr-layout-ribbon-segment e-de-ctnr-layout-tab"
                title="${this.localObj.getConstant('Spacing After')}">
                <div class="e-de-property-label-container">
                    <span class="e-de-icon-spaceafter"></span>
                    <span class="e-de-ribbon-property-label">${this.localObj.getConstant('Spacing After')}:</span>
                </div>
                <input id="${this.container.element.id + SPACING_AFTER_ID}" class="e-textbox" />
            </div>
        `;
        document.head.appendChild(script);
        // Register numeric textbox for initialization
        this.container.ribbon.numericTextBoxCollection.add(this.container.element.id + SPACING_AFTER_ID, 'simplifiedTab');
    }
    /**
     * Initializes the NumericTextBox instances
     *
     * @returns {void}
     */
    initializeNumericTextBoxes() {
        if (this.isInitilized) {
            const leftIndent = document.getElementById(this.container.element.id + RIBBON_ID + '_indent_left');
            const rightIndent = document.getElementById(this.container.element.id + RIBBON_ID + '_indent_right');
            const beforeSpacing = document.getElementById(this.container.element.id + RIBBON_ID + '_spacing_before');
            const afterSpacing = document.getElementById(this.container.element.id + RIBBON_ID + '_spacing_after');
            if (leftIndent.classList.contains('e-numerictextbox') && rightIndent.classList.contains('e-numerictextbox') &&
                beforeSpacing.classList.contains('e-numerictextbox') && afterSpacing.classList.contains('e-numerictextbox')) {
                return;
            }
        }
        this.resetInitializationState();
        this.isInitilized = true;
        this.initializeIndentLeftNumericBox();
        this.initializeIndentRightNumericBox();
        this.initializeSpacingBeforeNumericBox();
        this.initializeSpacingAfterNumericBox();
    }
    /**
     * Resets the initialization state to allow re-initialization after layout changes
     *
     * @returns {void}
     */
    resetInitializationState() {
        this.isInitilized = false;
        // Clean up existing instances if they exist before re-initialization
        if (this.indentLeftNumericBox) {
            this.indentLeftNumericBox.destroy();
            this.indentLeftNumericBox = undefined;
        }
        if (this.indentRightNumericBox) {
            this.indentRightNumericBox.destroy();
            this.indentRightNumericBox = undefined;
        }
        if (this.spacingBeforeNumericBox) {
            this.spacingBeforeNumericBox.destroy();
            this.spacingBeforeNumericBox = undefined;
        }
        if (this.spacingAfterNumericBox) {
            this.spacingAfterNumericBox.destroy();
            this.spacingAfterNumericBox = undefined;
        }
    }
    initializeIndentLeftNumericBox() {
        this.indentLeftNumericBox = this.initializeNumericBox(INDENT_LEFT_ID, {
            format: 'n1',
            value: 0,
            min: -1584,
            max: 1584,
            placeholder: this.localObj.getConstant('Before text'),
            change: this.onIndentLeftChange.bind(this)
        }, this.applyIndentLeft);
    }
    initializeIndentRightNumericBox() {
        this.indentRightNumericBox = this.initializeNumericBox(INDENT_RIGHT_ID, {
            format: 'n1',
            value: 0,
            min: -1584,
            max: 1584,
            change: this.onIndentRightChange.bind(this)
        }, this.applyIndentRight);
    }
    initializeSpacingBeforeNumericBox() {
        this.spacingBeforeNumericBox = this.initializeNumericBox(SPACING_BEFORE_ID, {
            format: 'n1',
            value: 0,
            min: -1,
            max: 1584,
            step: 6,
            showSpinButton: true,
            change: this.onSpacingBeforeChange.bind(this)
        }, this.applySpacingBefore);
    }
    initializeSpacingAfterNumericBox() {
        this.spacingAfterNumericBox = this.initializeNumericBox(SPACING_AFTER_ID, {
            format: 'n1',
            value: 0,
            min: -1,
            max: 1584,
            step: 6,
            showSpinButton: true,
            change: this.onSpacingAfterChange.bind(this)
        }, this.applySpacingAfter);
    }
    initializeNumericBox(id, options, applyMethod) {
        const element = document.getElementById(this.container.element.id + id);
        if (!element) {
            return null;
        }
        const numericBox = new NumericTextBox(Object.assign({ width: '100px', cssClass: 'e-de-paragraph-property', enablePersistence: false, floatLabelType: 'Always' }, options));
        numericBox.appendTo(element);
        const keydownHandler = (e) => {
            if (e.key === 'Enter') {
                setTimeout(() => {
                    applyMethod.call(this);
                }, 30);
            }
        };
        const blurHandler = applyMethod.bind(this);
        // Add event listeners
        element.addEventListener('keydown', keydownHandler);
        element.addEventListener('blur', blurHandler);
        /* eslint-disable */
        this.eventHandlers[id] = {
            element,
            keydownHandler,
            blurHandler
        };
        return numericBox;
    }
    onIndentLeftChange() {
        this.applyIndentLeft();
    }
    onIndentRightChange() {
        this.applyIndentRight();
    }
    onSpacingBeforeChange() {
        this.applySpacingBefore();
    }
    onSpacingAfterChange() {
        this.applySpacingAfter();
    }
    applyIndentLeft() {
        if (!this.indentLeftNumericBox) {
            return;
        }
        const leftIndent = this.indentLeftNumericBox.value;
        if (leftIndent !== null) {
            this.container.documentEditor.selection.paragraphFormat.leftIndent = leftIndent;
        }
    }
    applyIndentRight() {
        if (!this.indentRightNumericBox) {
            return;
        }
        const rightIndent = this.indentRightNumericBox.value;
        if (rightIndent !== null) {
            this.container.documentEditor.selection.paragraphFormat.rightIndent = rightIndent;
        }
    }
    applySpacingBefore() {
        if (!this.spacingBeforeNumericBox) {
            return;
        }
        const spacingBefore = this.spacingBeforeNumericBox.value;
        if (spacingBefore !== null && Math.round(this.container.documentEditor.selection.paragraphFormat.beforeSpacing * 1000) !== Math.round(spacingBefore * 1000)) {
            this.container.documentEditor.selection.paragraphFormat.beforeSpacing = spacingBefore;
        }
    }
    applySpacingAfter() {
        if (!this.spacingAfterNumericBox) {
            return;
        }
        const spacingAfter = this.spacingAfterNumericBox.value;
        if (spacingAfter !== null && Math.round(this.container.documentEditor.selection.paragraphFormat.afterSpacing * 1000) !== Math.round(spacingAfter * 1000)) {
            this.container.documentEditor.selection.paragraphFormat.afterSpacing = spacingAfter;
        }
    }
    /**
     * Updates the paragraph formatting properties in the UI
     *
     * @returns {void}
     * @private
     */
    updateSelection() {
        const paragraphFormat = this.container.documentEditor.selection.paragraphFormat;
        if (this.indentLeftNumericBox) {
            this.indentLeftNumericBox.value = paragraphFormat.leftIndent;
        }
        if (this.indentRightNumericBox) {
            this.indentRightNumericBox.value = paragraphFormat.rightIndent;
        }
        if (this.spacingBeforeNumericBox) {
            this.spacingBeforeNumericBox.value = paragraphFormat.beforeSpacing;
        }
        if (this.spacingAfterNumericBox) {
            this.spacingAfterNumericBox.value = paragraphFormat.afterSpacing;
        }
    }
    /**
     * Clean up resources when destroyed
     *
     * @returns {void}
     */
    destroy() {
        this.isInitilized = false;
        // Remove event listeners
        const keys = Object.keys(this.eventHandlers);
        for (const key of keys) {
            /* eslint-disable */
            const handler = this.eventHandlers[key];
            if (handler.element) {
                if (handler.keydownHandler) {
                    handler.element.removeEventListener('keydown', handler.keydownHandler);
                }
                if (handler.blurHandler) {
                    handler.element.removeEventListener('blur', handler.blurHandler);
                }
            }
        }
        // Clear event handlers
        this.eventHandlers = {};
        this.resetInitializationState();
        // Remove template elements
        const elementsToRemove = [
            document.getElementById(this.container.element.id + RIBBON_ID + '_indent_left'),
            document.getElementById(this.container.element.id + RIBBON_ID + '_indent_right'),
            document.getElementById(this.container.element.id + RIBBON_ID + '_spacing_before'),
            document.getElementById(this.container.element.id + RIBBON_ID + '_spacing_after')
        ];
        elementsToRemove.forEach((element) => {
            if (element && element.parentNode) {
                element.parentNode.removeChild(element);
            }
        });
        if (this.templateContainer && this.templateContainer.parentNode) {
            this.templateContainer.parentNode.removeChild(this.templateContainer);
            this.templateContainer = undefined;
        }
    }
}
